<template>
    <div class="settings-export">
        <ExportPreference v-if="isAdmin" :settings="props.settings" />
        <ExportHistory v-if="isActiveHistory" />
    </div>
</template>

<script setup lang="ts">
import ExportPreference from 'vcomponents/settings/export/ExportPreference.vue';
import ExportHistory from 'vcomponents/settings/export/ExportHistory.vue';
import { computed } from 'vue';
import { useStore } from 'vuex';

const props = defineProps({
    settings: {
        type: Object,
        required: true,
    },
});

const store = useStore();
const isAdmin = computed(() => store.state.user.isAdmin);
const isActiveHistory = computed(() => store.state.user.permissions?.acl?.view_exports);
</script>
